import {useFormik, useFormikContext} from 'formik'
import {useCrud} from '../../../services/loggedin/CrudContext'
import {Link, Navigate, useParams} from 'react-router-dom'
import {useEffect, useMemo, useState} from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {set} from 'date-fns'
import clsx from 'clsx'

const MySwal = withReactContent(Swal)

export const FormComponent = (props) => {
  let children = props.children ? props.children : null
  const customGet = props.customGet ? props.customGet : null
  const submitLoader = props.submitLoader ? props.submitLoader : true
  const errorHook = props.errorHook ? props.errorHook : (error) => {}
  let text_modificato = props.text_modificato ? props.text_modificato : 'Modificato con successo'
  let text_nuovo = props.text_nuovo ? props.text_nuovo : 'Creato con successo'
  const [loaded, setLoaded] = useState(0)
  const [item, setItem] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const {library} = useCrud()
  const [remoteErrors, setRemoteErrors] = useState({})
  const formik = useFormik(library?.f)
  const [otherError, setOtherErrors] = useState({})
  const fetch = useMemo(() => {
    return props.fetch ? props.fetch : []
  }, [props.fetch])

  const {id} = useParams()
  const isEdit = id ? true : false
  let toLoad = isEdit ? 1 : 0
  for (let key in fetch) {
    toLoad++
  }

  useEffect(() => {
    const fetchItem = async () => {
      if (customGet) {
        await library?.createFromCustomGet(customGet)
        formik.setValues(library?.f.initialValues)
      } else if (id) {
        await library?.createFromId(id)
       
        formik.setValues(library?.f.initialValues)
      }
      setLoaded((l) => l + 1)
      setItem(library?.getRawData());
    }
    fetchItem()
  }, [id, library])

  let fetchData = {}
  for (let key in fetch) {
    fetchData[key] = []
  }
  const [data, setData] = useState(fetchData)
  const [redirectTo, setRedirectTo] = useState(null)
  const redirect = props.redirect ? props.redirect : null

  useEffect(() => {
    let fetchData = {}
    if (isEdit) {
      fetchData = {id: id}
    }
    for (let key in fetch) {
      library?.customList(fetch[key], fetchData).then((data) => {
        setData((prevData) => {
          return {...prevData, [key]: data}
        })
        setLoaded((l) => l + 1)
      })
    }
  }, [fetch, library])

  library?.handleBeforeSubmit(async (data: any) => {
    console.log('BEFORE SUBMIT')
    setSubmitting(true)
    return data
  })

  library?.handleSubmitted((data: any) => {
    setSubmitting(false)
    if (data.success === 0) {
      console.log(data.errorMsg)
      if (data.errorMsg === 'Validation error') {
        setRemoteErrors(data.errors)
        console.log(data.errors)
      } else {
        errorHook(data)
      }
    } else {
      MySwal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer
          toast.onmouseleave = Swal.resumeTimer
        },
        icon: 'success',
        title: id ? text_modificato : text_nuovo,
      })

      redirect && setRedirectTo(redirect)
    }
  })
console.log(data);
  // const { setFieldValue } = useFormikContext();
  if (loaded < toLoad) {
    return (
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body p-9'>
          <div>
            <div className='d-flex  flex-row justify-content-center align-items-center mb-5'>
              <i className='ki-duotone ki-chart fa-spin fs-1'>
                <i className='path1'></i>
                <i className='path2'></i>
              </i>{' '}
              Loading...
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <>
      {redirectTo && <Navigate to={redirectTo} />}
      <div className='card mb-5 mb-xl-10'>
        <form
          onSubmit={async (e) => {
            e.preventDefault()
            let formik_validate = await formik.validateForm();
            let validate = true;
            if (Object.keys(formik_validate).length > 0) {
              for (let k in formik_validate) {
                validate = false
                formik.setFieldTouched(k, true)
              }
            }
            let otherValidation:any = await library?.otherValidation(formik.values,isEdit? parseInt(id+"") : null);
            if (Object.keys(otherValidation).length > 0) {
              setOtherErrors(otherValidation)
              validate = false
            }else{
              setOtherErrors({})
            }
            if(validate){
              formik.handleSubmit(e)
            }
            
            return false
          }}
          className='form'
        >
          <div className='card-body  '>{children(formik, data, remoteErrors, isEdit, otherError,item)}</div>

          <div className='card-footer d-flex justify-content-end py-6 px-9 border-gray-500'>
            <Link to={redirect} className='btn btn-secondary me-2'>
              Annulla
            </Link>

            <button
              type='submit'
              className={clsx('btn btn-primary', {
                disabled: submitting && submitLoader,
              })}
            >
              {submitLoader && submitting ? (
                <>
                  <i className='fa fa-spin fa-spinner'></i>{' '}
                </>
              ) : (
                ''
              )}
              Salva
            </button>
          </div>
        </form>
      </div>
    </>
  )
}
